import React from "react";
import DropdownExpand from "../../connectui/component/display/dropdown/DropdownExpand";
import Text from "../../connectui/component/display/Text";
import FlexContainer from "connectui/component/layout/FlexContainer";
import ChipText from "connectui/component/display/chip/ChipText";

const CustomLabel = ({label, count}) => (
  <FlexContainer gap={"8px"} pb={"12px"}>
    <Text weight="medium">{label}</Text>
    <ChipText
      text={count}
      sx={{
        backgroundColor: "#e3edff",
        "&:hover": {backgroundColor: "#cfe0fe"},
      }}
    />
  </FlexContainer>
);

const DropdownExpandExample = () => {
  return (
    <FlexContainer
      flexDirection="column"
      gap="18px"
      width="300px"
      margin="20px"
    >
      <DropdownExpand label="Money spent by Guest">
        <p>Details about thingies</p>
      </DropdownExpand>
      <DropdownExpand
        customLabel={<CustomLabel label="Check-in/out Dates" count={2} />}
      >
        <p>Check-in: 12/01/2023</p>
        <p>Check-out: 12/07/2023</p>
      </DropdownExpand>
      <DropdownExpand label="Listings">
        <p>Listing 1</p>
        <p>Listing 2</p>
      </DropdownExpand>
      <DropdownExpand
        customLabel={<CustomLabel label="Guests Tags" count={5} />}
      >
        <p>Pending Actions</p>
        <p>Guest in-house</p>
      </DropdownExpand>
    </FlexContainer>
  );
};

export default DropdownExpandExample;
